import {PropsWithChildren} from 'react';
import {Box, Stack} from '@chakra-ui/react';

export const AppAlert = (props: PropsWithChildren) => {
  return <Box layerStyle={'primaryModalAlert'} data-testid={'app-alert'}>
    <Stack>{props.children}</Stack>
  </Box>
};
